import React, { memo } from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { REDESIGN_TYPOGRAPHY } from '@/constants/residents/homeConstants';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

interface NewsfeedActionButtonsProps {
  onMyPosts: () => void;
  onSaved: () => void;
}

export const NewsfeedActionButtons: React.FC<NewsfeedActionButtonsProps> = memo(({
  onMyPosts,
  onSaved,
}) => {
  const { colors } = useThemeColors();

  const buttonStyle = [styles.button, { backgroundColor: colors.glass.buttonBg, borderColor: colors.glass.buttonBorder }];

  return (
    <View style={styles.row}>
      <TouchableOpacity
        style={buttonStyle}
        onPress={onMyPosts}
        activeOpacity={0.7}
        accessibilityRole="button"
        accessibilityLabel="My Posts"
      >
        <RESIDENTS_SVG_COMPONENTS.USER width={14} height={14} color={colors.text.muted} />
        <Text style={[styles.label, { color: colors.text.muted }]}>My Posts</Text>
      </TouchableOpacity>

      <TouchableOpacity
        style={buttonStyle}
        onPress={onSaved}
        activeOpacity={0.7}
        accessibilityRole="button"
        accessibilityLabel="Saved"
      >
        <RESIDENTS_SVG_COMPONENTS.STAR width={14} height={14} color={colors.text.muted} />
        <Text style={[styles.label, { color: colors.text.muted }]}>Saved</Text>
      </TouchableOpacity>
    </View>
  );
});

NewsfeedActionButtons.displayName = 'NewsfeedActionButtons';

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    gap: 10,
  },
  button: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    borderWidth: 1,
    borderRadius: 10,
    paddingVertical: 8,
    paddingHorizontal: 14,
  },
  label: {
    ...REDESIGN_TYPOGRAPHY.small,
  },
});
